import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=9636f262&scoped=true&"
import script from "./CompanyInformation.vue?vue&type=script&lang=js&"
export * from "./CompanyInformation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=9636f262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9636f262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9636f262')) {
      api.createRecord('9636f262', component.options)
    } else {
      api.reload('9636f262', component.options)
    }
    module.hot.accept("./CompanyInformation.vue?vue&type=template&id=9636f262&scoped=true&", function () {
      api.rerender('9636f262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/companies/CompanyInformation.vue"
export default component.exports